import { merchantListService } from "services";

const statesDdlColumn = () => {
	const loadOptions = async () => {
		try {
			const options = await merchantListService.getStates();

			return {
				options,
				hasMore: false,
			};
		} catch {
			return { options: [] };
		}
	};

	return {
		name: "states",
		type: "select" as const,
		loadOptions,
		getOptionLabel: option => option.state,
		getOptionValue: option => option.id,
		placeholder: "States",
	};
};

export default statesDdlColumn;
